import { render, staticRenderFns } from "./Cancellation.vue?vue&type=template&id=068b4846"
import script from "./Cancellation.vue?vue&type=script&lang=js"
export * from "./Cancellation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports